// @ts-nocheck
const getDomPath = (element) => {
    if (element.tagName === 'BODY') {
        return 'body';
    }
  
    var path = [];
  
    while (element && element.nodeType === Node.ELEMENT_NODE) {
        var selector = element.nodeName.toLowerCase(); // Use tag name
  
        if (element.id) {
            // If element has an ID, use it as it is a unique identifier
            selector += '#' + element.id;
            path.unshift(selector);
            break;
        }
  
        var siblingIndex = 1; // Start counting from 1
        for (var sibling = element.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
            // Count previous siblings of the same type
            if (sibling.nodeName.toLowerCase() === selector) {
                siblingIndex++;
            }
        }
        if (siblingIndex > 1) {
            // Use nth-of-type if the element is not the first of its type
            selector += ':nth-of-type(' + siblingIndex + ')';
        }
  
        path.unshift(selector);
        element = element.parentNode;
    }
  
    return path.join(' > ');
  }
  
  export default getDomPath;